/**
 * 세무관리 모듈 메뉴 (TX_)
 * hrMenuConfig 의 TOP/LEFT 에 병합한다. 추후 독립 시스템 분리 시 이 파일만 들어내면 된다.
 */
export const TX_TOP_MENUS = [
  { id: '700', label: '세무관리', icon: 'receipt', iconSrc: null, menuNo: '700', progId: 'TX' },
];

export const TX_LEFT_MENUS = {
  '700': [
    {
      id: '700',
      label: '세무관리',
      menuNo: '700',
      upperMenuId: '0',
      url: 'dir',
      children: [
        {
          id: '710',
          label: '기업등록',
          menuNo: '710',
          upperMenuId: '700',
          progId: 'TX_CLIENT_REG',
          screenId: 'TX_CLIENT_REG',
          menuType: 'crud',
          url: '/tax/client-company',
          componentPath: 'pages/tax/ClientCompanyRegister',
        },
        {
          id: '720',
          label: '원천세',
          menuNo: '720',
          upperMenuId: '700',
          url: 'dir',
          children: [
            {
              id: '721',
              label: '급여대장 업로드',
              menuNo: '721',
              upperMenuId: '720',
              progId: 'TX_WHT_PAYROLL',
              screenId: 'TX_WHT_PAYROLL',
              menuType: 'crud',
              url: '/tax/wht-payroll-upload',
              componentPath: 'pages/tax/WhtPayrollUpload',
            },
            {
              id: '722',
              label: '원천징수이행상황신고',
              menuNo: '722',
              upperMenuId: '720',
              progId: 'TX_WHT_REPORT',
              screenId: 'TX_WHT_REPORT',
              menuType: 'report',
              url: '/tax/wht-report',
              componentPath: 'pages/tax/WhtReport',
            },
          ],
        },
      ],
    },
  ],
};
